import { render, staticRenderFns } from "./CreateAudioPitch.vue?vue&type=template&id=3876a339"
import script from "./CreateAudioPitch.vue?vue&type=script&lang=js"
export * from "./CreateAudioPitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports